import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { EvalBidDto } from "../../../../autogen/bff-api";
import { evaluationRowOf } from "./useFocusSubjects";

export const EvaluationFocusActions = ({ bid }: { bid: EvalBidDto }) => {
  const { t } = useTranslation();
  const row = evaluationRowOf(bid);

  return (
    <Text fontSize="xs" color="smMuted">
      {row.isRejected
        ? t("This bid is rejected.")
        : t("{{scored}} of {{total}} criteria scored for {{supplier}}. Everything saves as you go.", {
          scored: row.reviewed,
          total: row.total,
          supplier: bid.supplierName,
        })}
    </Text>
  );
};
